import { toggleOffcanvas } from "@/components/OffcanvasComponent.vue";
import { useMainStore } from "@/store";
import { EOffcanvasViews, navigateCanvas } from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import { defineComponent } from "vue";
import { EventBusNames } from "@/utils/EventBus";

export default defineComponent({
    mounted() {
        if (this.session) {
            this.loading = true
            this.getCreditCards()
            this.getMySubs()
            this.$eventBus.$on(EventBusNames.GET_CREDIT_CARDS, () => this.getCreditCards())
        }
    },
    data() {
        return {
            loading: false,
            items: [],
            mySub: null as any
        }
    },
    computed: {
        session() {
            return useMainStore().session
        }
    },
    methods: {
        async getCreditCards() {
            try {
                const res = await this.$paymentService.getCreditCards()
                this.items = res.data
            } catch (error: any) {
                console.log(error)
                alert(error?.message)
            } finally {
                this.loading = false
            }
        },
        async handleSelectCard(card: any) {
            try {
                if (card.card_id == this.session?.favorite_card?.card_id) return
                this.$paymentService.setFavoriteCard(card)
                if (this.session?.subscription) {
                    await this.$subscriptionService.update(this.session?.subscription?.id, {
                        card_id: card?.card_id,
                    });
                    this.$userService.syncSession();
                }
                toggleOffcanvas('offcanvas_views')
                this.$eventBus.$emit(EventBusNames.REFRESH_MY_PLAN)
            } catch (error: any) {
                console.log(error)
                alert(error?.message)
            }
        },
        handleDeleteCard(card: any) {
            if (
                this.mySub &&
                this.mySub.isActive &&
                this.mySub?.card_info?.id == card.card_id
            ) {
                alert(
                    "Não é possível remover este cartão pois ele está vinculado a sua assinatura ativa. Para remover este cartão é necessário cancelar sua assinatura ativa"
                );
                return;
            } else {
                this.$eventBus.$emit(EventBusNames.SHOW_CONFIRMATION_ALERT, {
                    title: 'Remover cartão',
                    message: `Tem certeza que deseja remover o cartão •••• •••• •••• ${card.last_digits}?`,
                    confirmCallback: async () => {
                        this.handleConfirmDeleteCard(card)
                    },
                    confirmationButtonLabel: 'Sim, remover'
                })
            }
        },
        async handleConfirmDeleteCard(card: any) {
            try {
                await this.$paymentService.removeCard(card.card_id);
                const remainingCards = this.items.filter(
                    (elem: any) => elem.card_id != card.card_id
                );

                this.items = remainingCards


                if (card.card_id == this.session?.favorite_card?.card_id) {
                    if (remainingCards.length) {
                        this.handleSelectCard(remainingCards[0]);
                    } else {
                        this.handleSelectCard(null);
                    }
                }
            } catch (error: any) {
                console.log(error);
                alert(error?.message)
            }
        },
        handleAddCreditCard() {
            navigateCanvas(EOffcanvasViews.add_credit_card, null, false)
        },
        async getMySubs() {
            try {
                const subscription = this.session?.subscription;

                if (subscription?.id) {
                    let res = await this.$subscriptionService.show(subscription?.id);
                    let data = this.$subscriptionService.prepareSubscriptionInfo(res.data);
                    this.mySub = data;
                } else {
                    this.mySub = null;
                }
            } catch (error: any) {
                console.log("ERRO NO GET PLAN DETAILS NA MY PLAN SCREEN", error);
                // alert(error.message);
            }
        },
        closeModal() {
            toggleOffcanvas('offcanvas_views')
        }
    }
})